import 'css-chunksrc/client/pages/projectPage/synthesisPage/monitoring/milestones/milestone/styles.scss';export default {
  "milestone": "_milestone_1n70e_1",
  "popup": "_popup_1n70e_9",
  "icon": "_icon_1n70e_13",
  "late": "_late_1n70e_18",
  "flag": "_flag_1n70e_21",
  "infos": "_infos_1n70e_24",
  "done": "_done_1n70e_28",
  "name": "_name_1n70e_65",
  "group": "_group_1n70e_72",
  "label": "_label_1n70e_82",
  "text": "_text_1n70e_90",
  "left": "_left_1n70e_97"
};